<template>
  <div class="hello">
    <a
      class="app_home_cta"
      href="https://apps.apple.com/us/developer/christoph-gogolin/id511901280"
    >
      <img class="appstore" alt="Download Appstore" src="appstore_badge.png" />
    </a>
    <div class="hellotext hellotext1">
      <h1 style="font-size: 2rem">
        Gogolith Apps<br /><span
          style="font-size: 1.7rem; opacity: 0.7; font-weight: normal"
          >Fitness Apps for iOS & Apple Watch</span
        >
      </h1>
      <hr class="hr" />

      <div class="center">
        <h2>WorkoutGPT - AI for Health</h2>
        <p class="center">
          AI chat for your workout, sleep, and fitness data
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/workoutgpt">
        <div class="game">
          <div class="gameimage workoutgpt"></div>
          <div class="gametext">
            <h2>WorkoutGPT - AI for Health</h2>
            <p>
              Analyze workouts, steps, sleep, and training progress with AI
              chat, structured health tools, and charts.
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>

      <div class="center">
        <h2>Cycling Workout</h2>
        <p class="center">
          No accounts. No virtual worlds. Just cycling
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/cyclingworkoutapp">
        <div class="game">
          <div class="gameimage cycling"></div>
          <div class="gametext">
            <h2>Cycling Workout</h2>
            <p>
              Focused indoor cycling app for structured training on smart
              trainers.
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>

      <div class="center">
        <h2>Ski-Ergometer Workout</h2>
        <p class="center">
          Ready to take your skiing training to the next level?
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/skiingworkoutapp">
        <div class="game">
          <div class="gameimage ski"></div>
          <div class="gametext">
            <h2>Ski-Ergometer Workout</h2>
            <p>
              Reach your peak performance on the ski ergometer with Ski Workouts
              for Apple Watch.
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>

      <div class="center">
        <h2>Rowing Workout</h2>
        <p class="center">
          The missing indoor Rowing App for Apple Watch.
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/rowingworkoutapp">
        <div class="game">
          <div class="gameimage row"></div>
          <div class="gametext">
            <h2>Rowing Workout</h2>
            <p>
              Revolutionize your rowing journey with the groundbreaking Rowing
              Workouts app - now available for your Apple Watch!
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>

      <div class="center">
        <h2>Intervals - The Training Timer</h2>
        <p class="center">
          Ultimate Interval Workout Timer for Apple Watch
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/intervalsapp">
        <div class="game">
          <div class="gameimage int"></div>
          <div class="gametext">
            <h2>Intervals - The Training Timer</h2>
            <p>
              Mirror your custom interval workouts from Apple Watch to your
              iPhone. - now available for your Apple Watch!
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>

      <div class="center">
        <h2>Cycle Unit</h2>
        <p class="center">
          Ride outside or indoors — one app, one clean UI
          <br />
          <b></b>
        </p>
      </div>
      <router-link to="/cycle-unit">
        <div class="game">
          <div class="gameimage cycle"></div>
          <div class="gametext">
            <h2>Cycle Unit - Ride Tracker & Bike Computer</h2>
            <p>
              Ride smart. Anywhere. Indoor & outdoor cycling with Apple Watch +
              iPhone, FTMS trainers, and Ghost/Pacer.
              <br /><br />
              <small style="text-decoration: underline">
                GET MORE DETAILS
              </small>
            </p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Start",
  components: {},
  props: {
    msg: String,
  },
  methods: {
    showGallerie: (slide, gid, event) => {
      event.preventDefault();

      var gallery = new fsLightboxClass();
      gallery.data.name = gid;
      gallery.init(slide + 1);
    },
  },
  activated: function () {
    console.log("activated", this._inactive, this.item);
  },
  deactivated: function () {
    console.log("deactivated", this._inactive, this.item);
  },
  mounted: function () {},
  destroyed: function () {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.app_home_cta {
  position: absolute;
  right: 10%;
  display: block;
  top: 7px;
  width: 80%;

  img {
    width: 60%;
    max-width: 180px;
  }

  @media all and (min-width: 600px) {
    display: none;
  }
}

.hr {
  opacity: 0.5;
  max-width: 200;
  width: 200px;
}
.game {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  min-height: 100px;
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  font-size: 0.9rem;

  .gameimage {
    width: 100%;
    padding-top: 100%;
    margin-bottom: 20px;
    box-sizing: border-box;
    background: url("../assets/header_bg_l_1.gif");
    background-size: 240%;
    background-position: 280px -20px;
    background-color: #121212;
    border-radius: 13px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .gameimage.jrr {
    background: url("../assets/jrr_sc_12.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.row {
    background: url("../assets/157x0w.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.int {
    background: url("../assets/intervals_icon_1024.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.ski {
    background: url("../assets/ski_icon_1024.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.cycle {
    background: url("../assets/cycle/icon_v01.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.cycling {
    background: url("../assets/icon-cycling.png");
    background-size: cover;
    background-position: 0;
  }

  .gameimage.workoutgpt {
    background: url("../assets/ai/appicon.png");
    background-size: cover;
    background-position: 0;
  }

  .gametext {
    text-decoration: none;
    color: #fff;
    text-align: center;

    p {
      text-align: center;
    }
    h2 {
      margin: 0;
      font-size: 1.2rem;
    }
  }

  @media all and (min-width: 500px) {
    flex-direction: row;
    align-items: center;
    padding: 8px;
    font-size: 1rem;

    .gameimage {
      width: 150px;
      height: 150px;
      padding-top: 0;
      margin-bottom: 0px;
    }

    .gametext {
      text-align: left;
      p {
        text-align: left;
      }
    }
  }
}
.hellotext p.center {
  text-align: center;
}
h3 {
  margin: 40px 0 0;
}
ul {
  padding: 0;
  text-align: left;
}
li {
  margin: 10px 10px 4px 20px;
}
a {
  color: #42b983;
  text-decoration: none;
}
.slider {
  div {
    height: 270px;
    text-align: center;
    img {
      border-radius: 10px;
      max-height: 210px;
    }
  }
}

.hello {
  max-width: 800px;
  margin: 0px auto;
  position: relative;
}

.helloslider {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 20px;

  margin-bottom: 20px;
}

.hellotext {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;

  &.hellotext1 {
    padding-top: 50px;

    @media all and (min-width: 600px) {
      padding-top: 20px;
    }
  }

  p {
    text-align: left;
  }

  &.center {
    p {
      text-align: center;
    }
  }
}
</style>
